import { Component, ContentChild, Input, TemplateRef } from "@angular/core";
import { AbstractControl, FormControlDirective, FormControlName, NgControl, NgModel } from "@angular/forms";

import { NzFormControlComponent } from "ng-zorro-antd/form";

@Component({
  selector: "ui-form-control",
  exportAs: "uiFormControl",
  templateUrl: "form-control.component.html",
})
export class UiFormControlComponent extends NzFormControlComponent {
  @ContentChild(NgControl, { static: false }) public defaultValidateControl?: FormControlName | FormControlDirective;
  @Input("uiSuccessTip") public nzSuccessTip?: string | TemplateRef<{ $implicit: AbstractControl | NgModel }>;
  @Input("uiWarningTip") public nzWarningTip?: string | TemplateRef<{ $implicit: AbstractControl | NgModel }>;
  @Input("uiErrorTip") public nzErrorTip?: string | TemplateRef<{ $implicit: AbstractControl | NgModel }>;
  @Input("uiValidatingTip") public nzValidatingTip?: string | TemplateRef<{ $implicit: AbstractControl | NgModel }>;
  @Input("uiExtra") public nzExtra?: string | TemplateRef<void>;
  @Input("uiAutoTIps") public nzAutoTips: Record<string, Record<string, string>> = {};
  @Input("uiDisableAutoTips") public nzDisableAutoTips: boolean | "default" = "default";

  @Input("formHasFeedback")
  set formHasFeedback(value: boolean) {
    this.nzHasFeedback = value;
  }

  get formHasFeedback(): boolean {
    return this.nzHasFeedback;
  }

  @Input("formValidateStatus")
  set formValidateStatus(value: string | AbstractControl | FormControlName | NgModel) {
    this.nzValidateStatus = value;
  }
}
